import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KundenServiceConfig = {
  name: "Kunden",
  annotations: []
} as ServiceConfig;